import React from 'react';
import PredictLayout from './PredictLayout';

const MobilePredictLayout = () => <PredictLayout />;

export default MobilePredictLayout;
